'use client';

import i18n, {InitOptions} from 'i18next';
import {initReactI18next} from 'react-i18next';

import {DEFAULT_LOCALE, DEFAULT_NS, LOCALES} from './locales';

export type Locale = keyof typeof LOCALES;

export const initTranslations = (locale: Locale) => {
  const options: InitOptions = {
    load: 'languageOnly',

    ns: [DEFAULT_NS],
    fallbackNS: DEFAULT_NS,
    defaultNS: DEFAULT_NS,

    lng: locale,
    fallbackLng: DEFAULT_LOCALE,

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  };

  i18n.use(initReactI18next).init(options);

  Object.entries(LOCALES).forEach(([locale, resources]) => {
    i18n.addResourceBundle(locale, DEFAULT_NS, resources[DEFAULT_NS]);
  });

  return i18n;
};
